import {Tracking} from './tracking/tracking';
import {MoreBox} from './components/moreBox';

new Tracking().init();

o_global?.eventQBus?.on('ft5.richContent.variationChanged', initMoreBox);

function initMoreBox() {
    const moreBoxElement: HTMLElement | null = document.querySelector('.js_rc_moreBox');

    if (moreBoxElement) {
        new MoreBox(moreBoxElement, 120, false);
    }
}